import React, { createContext, type ReactNode, useContext, useState } from "react"
import { SignUp } from "../Objects/SignUp/SignUp"

interface SignUpContextProps {
  signUp: SignUp
  setSignUp: React.Dispatch<React.SetStateAction<SignUp>>
  handleInitialValue: (data?: Partial<SignUp>) => void
  updateSignUp: (data: Partial<SignUp>) => void
  handleSubmitForm: () => SignUp
}

const SignUpContext = createContext<SignUpContextProps | undefined>(undefined)

interface LoadProviderProps {
  children: ReactNode
}

export const SignUpProvider: React.FC<LoadProviderProps> = ({ children }) => {
  const signUpData = useSignUp()

  return <SignUpContext.Provider value={signUpData}>{children}</SignUpContext.Provider>
}

export const useSignUp = () => {
  const [signUp, setSignUp] = useState<SignUp>(new SignUp())

  const handleInitialValue = (data?: Partial<SignUp>) => {
    if (data) setSignUp(new SignUp(data))
  }

  const updateSignUp = (data: Partial<SignUp>) => {
    setSignUp((prev) => new SignUp({ ...prev, ...data }))
  }

  const handleSubmitForm = (): SignUp => {
    return new SignUp(signUp)
  }

  return {
    signUp,
    setSignUp,
    handleInitialValue,
    updateSignUp,
    handleSubmitForm,
  }
}

export const useSignUpContext = (): SignUpContextProps => {
  const context = useContext(SignUpContext)

  if (!context) {
    throw new Error("useSignUpContext deve ser usado dentro de um SignUpProvider")
  }

  return context
}
